"use strict";

const _ = require("lodash");

function SettingsOrgUsersController(
  $rootScope,
  $scope,
  $state,
  Flux,
  AnalyticsService,
  invitations,
  organization,
  PlanStore,
  AppDialogsActions,
  SettingsActions,
  SettingsService,
  SettingsStore,
  IdentityService,
  NgTableParams
) {
  const vm = this;
  const OrganizationStore = Flux.Store.get("OrganizationStore");
  vm.activeUserId = _.get($state, ["params", "user"]);
  vm.state = "overview";
  vm.org = organization;
  vm.requests = invitations;
  vm.isOrganizationAdmin = IdentityService.isOrganizationAdmin();
  vm.showSpinner = true;
  vm.cantAddSeats = false;

  vm.setPlanData = () => {
    if (PlanStore.get("orgPlan").externalSubscriptionId) {
      if (!!PlanStore.get("externalPlan") === false) {
        PlanStore.preloadOrgPlanData().then(() => {
          vm.totalSeats = PlanStore.get("orgPlan").seats;
          vm.hasPlan = true;
        });
      } else {
        vm.totalSeats = PlanStore.get("orgPlan").seats;
        vm.hasPlan = true;
      }
      if (!_.isEmpty(PlanStore.get("externalPlan"))) {
        if (
          vm.totalSeats <= PlanStore.get("externalPlan").meta_data.seats.base ||
          vm.org.users.length >= vm.totalSeats
        ) {
          vm.cantAddSeats = true;
        } else {
          vm.cantAddSeats = false;
        }
      } else {
        vm.hasPlan = false;
        vm.cantAddSeats = true;
      }
    } else {
      vm.hasPlan = false;
    }
  };

  vm.viewUser = id => {
    console.log("go to", id);

    $state.go(SettingsService.USER_DETAIL_STATE, {
      user: id
    });

    vm.state = "detailed";
  };

  vm.tableParams = new NgTableParams(
    {
      count: vm.org.users.length,
      // initial sort order
      sorting: {
        firstName: "asc"
      }
    },
    {
      filterDelay: 0,
      dataset: vm.org.users,
      counts: []
    }
  );

  /**======== Button Actions ========**/
  vm.addNewUser = () => {
    if (!PlanStore.get("orgPlan").isEnabled) {
      AnalyticsService.track("[CORE] Subscription", "Invite - Disabled Plan", {
        fromAdminSettings: true
      });
      AppDialogsActions.MustBePayingCustomer.dispatch();
    } else {
      SettingsActions.OpenDialog.dispatch("invitation", {});
    }
  };

  vm.changeSeatsDialog = command => {
    if (!vm.isOrganizationAdmin) {
      SettingsActions.OpenDialog.dispatch("insufficientPrivileges", {
        message:
          "You must be an Organization Administrator to modify user seats"
      });
    } else if (
      !PlanStore.get("orgPlan").isEnabled ||
      PlanStore.get("externalSubscription").status === "cancelled"
    ) {
      AppDialogsActions.MustBePayingCustomer.dispatch();
    } else {
      // Add || Remove
      SettingsActions.OpenDialog.dispatch("changeUserSeats", {
        plan: PlanStore.get("orgPlan"),
        action: command || "Add"
      });
    }
  };

  const handleRequest = (status, user) => {
    const eventName = ["Invitation", _.capitalize(status)].join(" ");
    const id = SettingsService.generateGrowlId(status, user);
    const message = SettingsService.generateRequestGrowlMessage(
      vm.org,
      user,
      status
    );
    const growlData = {
      id: id,
      message: message
    };
    const index = vm.requests.indexOf(user);
    const data = {
      status: status,
      invitationId: user.id
    };

    vm.requests.splice(index, 1);
    // TODO: remove this and use pubnub to update user list for approved users only
    // Map the userInvitiation object to a user Object
    if (status === "approved") {
      user.status = status = "Active";
      vm.org.users.push(user);
    } else if (status === "denied") {
      user.status = status = "Denied";
    }

    AnalyticsService.track("[CORE] Invitations", eventName, {
      organization: organization.name,
      projectName: user.projects.name,
      invitedBy: user.fromName,
      invitee: [user.firstName, user.lastName].join(" "),
      organizationId: user.organizationId,
      projectId: user.projectId,
      state: user.status
    });

    SettingsService.growl(growlData);
    SettingsActions.RequestHandled.dispatch(data);
  };

  vm.approve = user => {
    if (vm.org.users.length >= vm.totalSeats) {
      SettingsActions.NotEnoughSeats.dispatch();

      return;
    }
    OrganizationStore.$set("dirty", true);
    handleRequest("approved", user);
  };

  vm.deny = user => {
    handleRequest("denied", user);
  };

  vm.handleNewMemberAdded = () => {
    return OrganizationStore.loadOrganization().then(newOrg => {
      vm.org = newOrg;
      return vm.org;
    });
  };

  vm.handleCloseDetailView = () => {
    vm.state = "overview";
    vm.activeUserId = null;
  };

  vm.handleOpenDetailView = () => {
    vm.state = "detailed";
  };

  /**======     Event Listeners    ======**/
  $rootScope.$on("$stateChangeStart", (event, toState, toParams) => {
    // ensure that this controller always recognizes when the detailed view is open, even on page refresh
    if (toParams.user) {
      vm.state = "detailed";
    }

    vm.activeUserId = toParams.user;
  });

  vm.setPlanData();

  if ($state.params) {
    if ($state.params.command === "seats") {
      vm.changeSeatsDialog("Add");
    }
  }

  SettingsStore.on(
    SettingsStore.Events.InvitationSuccess,
    vm.handleNewMemberAdded.bind(vm),
    $scope
  );
  SettingsStore.on(
    SettingsStore.Events.CloseDetailView,
    vm.handleCloseDetailView.bind(vm),
    $scope
  );
  SettingsStore.on(
    SettingsStore.Events.OpenDetailView,
    vm.handleOpenDetailView.bind(vm),
    $scope
  );
  PlanStore.on(PlanStore.Events.Changed, vm.setPlanData.bind(vm), $scope);
}

SettingsOrgUsersController.$inject = [
  "$rootScope",
  "$scope",
  "$state",
  "sbFlux",
  "AnalyticsService",
  "invitations",
  "organization",
  "PlanStore",
  "AppDialogsActions",
  "SettingsActions",
  "SettingsService",
  "SettingsStore",
  "IdentityService",
  "NgTableParams"
];

module.exports = SettingsOrgUsersController;



// WEBPACK FOOTER //
// ./src/app/settings/orgUsers/SettingsOrgUsersController.js